import {Injectable} from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import {UserService} from "../services/user.service";
import {BaseService} from "../services/_base.service";
import { catchError, Observable, throwError } from 'rxjs';
import { Vehicle } from '../models/vehicle.model';

@Injectable({
  providedIn: 'root'
})
export class VehiclesService extends BaseService{

  constructor(http: HttpClient, userService: UserService) {
    super()
  }
  all(filters?, search?) {
    const params = {};
    if (filters) {
      for (const filter in filters) {
        if (filter) {
          params[filter]=filters[filter].toString();
        }
      }
    }
    if (search) {
      params['query']=search;
    }
    return this.http.get(this.apiURL + '/vehicles', this.getParams(params));
  }

  get(id:number): Observable<HttpResponse<Vehicle>> {
    return this.http.get<Vehicle>(this.apiURL + '/vehicles/' + id, this.getParams())
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error fetching vehicle:', error);
          return throwError(() => error);
        }),
      );
  }

  processVehicle(id){
    return this.http.put(this.apiURL+'/vehicles/'+id,{},this.getParams())
  }
  totalsByStatus() {
    return this.http.get(this.apiURL + '/vehicles/totals_by_status', this.getParams());
  }
}
